"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { useBreakpoint } from "@/shared/hooks/use-breakpoint";

export function Footer() {
  const t = useTranslations();

  const { isPc, isTablet } = useBreakpoint();

  return (
    <div className="footer pc:h-[295px] pc:px-0 pc:py-12 tb:px-10 tb:py-12 tb:h-[333px] pc:justify-center relative z-20 flex h-auto items-center justify-start bg-gray-900 px-4 pt-10 pb-7.5">
      {!isPc ? (
        <div className="flex w-full flex-col">
          <Link href="/" className="tb:mb-6 mb-5">
            <img src={"/images/home/logo.webp"} alt="logo" className="tb:w-[192px] tb:h-[42px] h-[26px] w-[120px]" />
          </Link>

          {isTablet ? (
            <div className="mb-4.5 flex items-center gap-3">
              <Link href="/terms" className="body-sm-regular text-white">
                {t("fot_tcu")}
              </Link>
              <div className="h-3 w-[1px] bg-white/20" />
              <Link href="/privacy-policy" className="body-sm-regular text-white">
                {t("fot_pac")}
              </Link>

              <div className="h-3 w-[1px] bg-white/20" />
              <Link href="/software-terms" className="body-sm-regular text-white">
                {t("fot_sna")}
              </Link>
            </div>
          ) : (
            <div className="mb-4.5 flex flex-col gap-[6px]">
              <div className="flex items-center gap-[6px]">
                <Link href="/terms" className="body-sm-regular text-white">
                  {t("fot_tcu")}
                </Link>
                <div className="h-[10px] w-[1px] bg-white/20" />
                <Link href="/privacy-policy" className="body-sm-regular text-white">
                  {t("fot_pac")}
                </Link>
                <div className="h-[10px] w-[1px] bg-white/20" />
              </div>

              <Link href="/software-terms" className="body-sm-regular text-white">
                {t("fot_sna")}
              </Link>
            </div>
          )}

          <div className="flex flex-col gap-2">
            {isTablet ? (
              <>
                <div className="flex items-center gap-2">
                  <span className="body-sm-regular flex-shrink-0 text-gray-400">
                    {t("fot_name")} : {t("fot_name_data")}
                  </span>

                  <div className="h-3 w-[1px] bg-white/20" />
                  <div>
                    <span className="body-sm-regular flex-shrink-0 text-gray-400">
                      {t("fot_ads")} : {t("fot_ads_data")}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="flex gap-3">
                    <span className="body-sm-regular flex-shrink-0 text-gray-400">
                      {t("fot_bus")} : {t("fot_bus_data")}
                    </span>
                  </div>
                  <div className="h-3 w-[1px] bg-white/20" />

                  <div className="flex gap-3">
                    <span className="body-sm-regular flex-shrink-0 text-gray-400">
                      {t("fot_no")} : {t("fot_no_data")}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="body-sm-regular flex-shrink-0 text-gray-400">
                    {t("fot_E-mail")} : {t("fot_E-mail_data")}
                  </span>
                  <div className="h-3 w-[1px] bg-white/20" />
                  <div>
                    <span className="body-sm-regular flex-shrink-0 text-gray-400">
                      {t("fot_call")} : {t("fot_call_data")}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_name")} : {t("fot_name_data")}
                </span>

                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_ads")} : {t("fot_ads_data")}
                </span>

                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_bus")} : {t("fot_bus_data")}
                </span>

                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_no")} : {t("fot_no_data")}
                </span>
                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_E-mail")} : {t("fot_E-mail_data")}
                </span>

                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_call")} : {t("fot_call_data")}
                </span>
              </>
            )}
          </div>

          <div className="my-4.5 h-[1px] w-full bg-white/20" />

          <span className="body-sm-regular text-gray-500">{t("fot_cop")}</span>
        </div>
      ) : (
        <div className="h-full w-full max-w-[1280px]">
          <div className="flex items-center justify-between">
            <Link href="/" className="mb-4">
              <img src={"/images/home/logo.webp"} alt="logo" width={174} height={38} />
            </Link>

            <div className="flex items-center gap-5">
              <Link href="/terms" className="body-sm-regular text-white">
                {t("fot_tcu")}
              </Link>
              <div className="h-4 w-[1px] bg-white/20" />
              <Link href="/privacy-policy" className="body-sm-regular text-white">
                {t("fot_pac")}
              </Link>

              <div className="h-4 w-[1px] bg-white/20" />

              <Link href="/software-terms" className="body-sm-regular text-white">
                {t("fot_sna")}
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <div>
                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_name")}: {t("fot_name_data")}
                </span>
              </div>
              <div className="h-3 w-[1px] bg-white/20" />
              <div>
                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_ads")}: {t("fot_ads_data")}
                </span>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <div>
                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_bus")}: {t("fot_bus_data")}
                </span>
              </div>

              <div className="h-3 w-[1px] bg-white/20" />

              <div>
                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_no")}: {t("fot_no_data")}
                </span>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <div>
                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_E-mail")}: {t("fot_E-mail_data")}
                </span>
              </div>
              <div className="h-3 w-[1px] bg-white/20" />
              <div>
                <span className="body-sm-regular flex-shrink-0 text-gray-400">
                  {t("fot_call")}: {t("fot_call_data")}
                </span>
              </div>
            </div>
          </div>

          <div className="my-4.5 h-[1px] w-full bg-white/20" />

          <span className="body-sm-regular text-gray-500">{t("fot_cop")}</span>
        </div>
      )}
    </div>
  );
}
